import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "navs" }

import { getUrlParam, safeParseInt, safeRouter } from '@/utils/util';
import { onMounted, onUnmounted, reactive } from 'vue';
import Customer from '@/components/customer.vue'

import router from "@/router"
import store from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'floatnav',
  props: {
    auth: {
        type: Boolean,
        default: true,
    },
    query: {
        type: Boolean,
        default: true,
    },
    start: {
        type: Boolean,
        default: true,
    },
    customer: {
        type: Boolean,
        default: true,
    },
    fission: {
        type: Boolean,
        default: true,
    },
},
  setup(__props) {

const props = __props;

const state = reactive({
    info_url: '',
    info_type: 0,
    info_desc: '',
    showCustomer: false,
    showDialog: false,
    fission: 0,
    merchant: 0,
    showFission: false,
})

const param = reactive({
    /** 链接ID */
    lid: 0,
    /** 应用ID */
    id: 0
})

const onPageScroll = () => {
    const navs = document.querySelector('.navs')
    if (navs) {
        // 滚动到 200px 时 opacity 为 0.5, 0-50 时为 1, 50-200 时为 1-0.5
        const opacity = Math.max(0.75, 1 - (window.scrollY - 400) / 400)
        navs.setAttribute('style', 'opacity: ' + opacity)
    }
}
onMounted(() => {
    const lidStr = getUrlParam('lid')
    if (lidStr) {
        param.lid = safeParseInt(lidStr)
    }
    const idStr = getUrlParam('id')
    if (idStr) {
        param.id = safeParseInt(idStr)
    }
    window.addEventListener('scroll', onPageScroll)
    const info: StoreState = store.getters
    state.info_url = info.infoUrl
    state.info_type = info.infoType
    state.info_desc = info.infoDesc
    state.fission = info.fission
    state.merchant = info.merchant
    state.showFission = info.fission > 0
    state.showCustomer = info.infoType == 1 && info.infoUrl != ''
})
onUnmounted(() => {
    window.removeEventListener('scroll', onPageScroll)
})

const toQueryPage = () => {
    safeRouter(router, 'query', param)
}

const toAuthPage = () => {
    safeRouter(router, 'auth', param)
}

const toCustomerPage = () => {
    state.showDialog = true
}

const toHomePage = () => {
    safeRouter(router, 'start', param)
}

const toFissionPage = () => {
    safeRouter(router, 'fission', param)
}

const onCustomerClose = () => {
    state.showDialog = false
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (props.query)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "item query",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (toQueryPage()))
          }, "订单查询"))
        : _createCommentVNode("", true),
      (props.auth)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "item auth",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (toAuthPage()))
          }, "实名认证"))
        : _createCommentVNode("", true),
      (props.customer && state.showCustomer)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "item customer",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (toCustomerPage()))
          }, "在线客服"))
        : _createCommentVNode("", true),
      (props.fission && state.showFission)
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: "item fission",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (toFissionPage()))
          }, "赚佣金"))
        : _createCommentVNode("", true),
      (props.start)
        ? (_openBlock(), _createElementBlock("div", {
            key: 4,
            class: "item home",
            onClick: toHomePage
          }, "首页"))
        : _createCommentVNode("", true)
    ]),
    (state.showDialog)
      ? (_openBlock(), _createBlock(Customer, {
          key: 0,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (onCustomerClose()))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})